import { MDBAlert, MDBBtn, MDBSpinner } from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import {
  getCallFlows,
  getExistingUserLocations,
  getMisc,
  getSpecificCallFlows,
  updateCallFlows,
} from "../../../apiclients/streamsapi_bridge";
import TelephoneNumbers from "../../../components/TelephoneNumbers";
import SaveChanges from "../../../components/topviews/saveCancel";
import { useAdminContext } from "../../../components/adminstore/Admin-Context";

export default function EditCallFlow(props) {
  const [editid , setEditid] = useState();
 
  const location = useLocation();
  console.log("state values::::" + JSON.stringify(location.state));
  console.log("state values::::" + JSON.stringify(location?.state?.call_flow.call_flow_id));
  
  useEffect(() => {
    // Check if location and location.state are available
    if (location?.state?.call_flow?.call_flow_id) {
      setEditid(location.state.call_flow.call_flow_id);
      console.log("setEdit:::" + editid);
    }
  }, [location]);

  console.log(props);
  if (!props.call_flow) {
    props = location.state;
  }
  const { t, i18n } = useTranslation();
  const [autoext, setAutoext] = useState(true);
  const [extCheckFlag, setextCheckFlag] = useState(0);
  const [checkAvailbility, setCheckAvailbility] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [locationId, setLocationId] = useState("");
  const { setEdited } = useAdminContext();

  // const [error, setError] = useState({});
  const thName = useRef();
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    reset,
    setError,
    clearErrors,
    formState,
  } = useForm({
    defaultValues: {
      name: props.call_flow.name,
      extension: props.call_flow.extension,
    },
  });
  const { errors, isDirty } = formState;

  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();



  const addPhoneNumbers = async (fieldName) => {
    setIsloading(true);
    let updates = {
      reqid: 55,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,

      call_flow_id: props.call_flow.call_flow_id,
      [fieldName]: updatePHNum,
    };

    console.log("------------------------------");
    console.log(updates);
    let saverep = await updateCallFlows(updates);

    let saverepeMsg = await saverep.json();
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (fieldName === "added_dids") {
        // updatePHNum.forEach((num) => {
        //   if (!selectedPHnums.includes(num)) {
        //     setSelectedPHnums((prev) => [...prev, num]);
        //   }
        // });

        setSuccessMessage(`Telephone Number ${updatePHNum} added successfully.`); // success pop up message.
        //setHgUpdated(true);
      } else {
        const updateAddPHNum = selectedPHnums.filter(
          (num) => !updatePHNum.includes(num)
        );
        setSelectedPHnums(updateAddPHNum);
        setdbPhoneNumbers(updateAddPHNum);
        setSuccessMessage(
          `Telephone Number ${updatePHNum} removed successfully.`
        ); // success pop up message.
        //setHgUpdated(true);
      }
    } else {
      if (fieldName === "removed_dids") {
        const modifynum = selectedPHnums.filter(
          (num) => !updatePHNum.includes(num)
        );
        setSelectedPHnums([...modifynum, ...updatePHNum]);
        setdbPhoneNumbers([...modifynum, ...updatePHNum]);
      }
    }
    setIsloading(false);
    console.log("===================================");
    console.log(saverep);
  };
  let windowsMap = {};
  const onsubmit = async (data) => {
    let updates = {};
    if (isDirty) {
      let updates = {};
      console.log("In submit....");
      updates = {
        reqid: 55,
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        name: data.name,
        loc_id: data.location,
        extension: parseInt(data.extension),
        call_flow_id: props.call_flow.call_flow_id,
      };
      setIsloading(true);
      let saverep = await updateCallFlows(updates);
      setTimeout(() => {
        setIsloading(false);
      }, 2000);
      let saverepeMsg = await saverep.json();
      console.log(saverepeMsg);
      if (saverepeMsg.status && saverepeMsg.status == "success") {

        
        const response = await getCallFlows(
          JSON.parse(sessionStorage.getItem("admin_session")).siteid
        );
        const rawData = await response.json();
        let tempcallflow = rawData.call_flows.filter(
          (cf) => cf.name === data.name
        );
        let tflows = data.new ? [tempcallflow[0], ...rawData.call_flows] : [...rawData.call_flows];
        const state = {
          callflow: tempcallflow[0],
          callflow_list: tflows.sort((a, b) => a?.name?.localeCompare(b?.name)),
        };
        localStorage.setItem("callflowState", JSON.stringify(state));
        localStorage.setItem("veditor_cfid", JSON.stringify(tempcallflow[0]));
        const windowName = `callflowWindow`;
    
        // Check if the window with this name already exists
        if (windowsMap[windowName] && !windowsMap[windowName].closed) {
          // Focus on the existing window if it's already open
          windowsMap[windowName].focus();
          windowsMap[windowName].location.reload(); // Reload the window content
        }


        localStorage.setItem(
          "s_message",
          "CallFlow " + data.name + " updated successfully."
        );
        navigate("/callflowlanding", {
          state: { id: editid , flag: 1 }
        });
         } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            setError(err.param_name, {
              type: "server",
              message: err.message,
            });
            const fieldElement = document.querySelector(
              `input[name="${err.param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
            }
          });
        }
      }
    }
  };
  const isdirtyFields =
    Object.keys(formState.dirtyFields).length === 0 ? false : true;

  useEffect(() => {
    setEdited(isdirtyFields);
  }, [isdirtyFields])

  async function checkAvailability(e) {
    if (e.target.value.trim() == "") {
      return;
    }
    setextCheckFlag(1);
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { check_ext: e.target.value }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    if (tdata.check_ext) {
      setCheckAvailbility(true);
      setError("extension", { message: "Extension is available" });
    } else {
      setCheckAvailbility(false);
      setError("extension", { message: "Extension is not available" });
    }
    console.log(tdata);
  }

  const [selectedPHnums, setSelectedPHnums] = useState([]);
   const [dbPhoneNumbers, setdbPhoneNumbers] = useState([]);
  const [sourceNumber, setSourceNumber] = useState([]);
  const [updatePHNum, setUpdatePHNum] = useState([]);

  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);

  useEffect(() => {
    if (updatePHNum.length > 0 && updateNumbersExecuted) {
      addPhoneNumbers("added_dids");
      setSelectedPHnums((prev) => [...prev, ...updatePHNum]);
      setdbPhoneNumbers((prev) => [...prev, ...updatePHNum]);
      setUpdateNumbersExecuted(false);
    }
  }, [updatePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (updatePHNum.length > 0 && deleteNumberFlag) {
      const updateAddPHNum = selectedPHnums.filter(
        (num) => !updatePHNum.includes(num)
      );
      setSelectedPHnums(updateAddPHNum);
      setdbPhoneNumbers(updateAddPHNum);
      addPhoneNumbers("removed_dids");
      setDeleteNumberFlag(false);
    }
  }, [updatePHNum, deleteNumberFlag]);

  const [message, setMessage] = useState([]);
  useEffect(() => {
    if (successMessage) {
      setMessage(true);
      setTimeout(() => {
        setMessage(false);
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  async function getFreePhoneNumbers() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["free_dids"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + basicInfo);
    setSourceNumber(basicInfo.misc.free_dids);
    setSelectedPHnums(props.call_flow.added_dids);
    setdbPhoneNumbers(props.call_flow.added_dids);
  }
  async function getLocations() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));

    const response = await getExistingUserLocations(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const data = await response.json();
    if (!data) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + data);
    setLocations(data.locations);
  }
  async function getCallFlowInfo() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));

    const response = await getSpecificCallFlows(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      props.call_flow.call_flow_id
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const data = await response.json();

    console.log("--------------------------------");
    console.log(data);
    if (!data) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    setSelectedPHnums(data.added_dids);
    setdbPhoneNumbers(data.added_dids);
  }
  useEffect(() => {
    getFreePhoneNumbers();
    getLocations();
    getCallFlowInfo();
  }, []);
  function closeSave(e) {
    //navigate("/userlanding");
    reset();
  }
  return (
    <>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      <div>
        <form>
          <div className="add-numbermain">
            <div className="tel-numbers">{t("Name")}</div>
            <div className="d-flex w-30">
              <div className="phoneselect w-100">
                <input
                  type="text"
                  maxLength={50}
                  id="namecallflow"
                  className="form-control"
                  {...register("name", { required: "Name is required" })}
                />
                {errors.name && (
                  <p className="text-danger text-start">{errors.name.message}</p>
                )}
              </div>
            </div>
          </div>

          <div className="add-numbermain">
            <div className="tel-numbers">{t("extension")}</div>
            <div className="w-30">
              <input
                className="w-100"
                type="text"
                maxLength={5}
                {...register("extension", {
                  setValueAs: (value) => Number(value),
                  required: "Extension is required",
                  minLength: {
                    value: 3,
                    message: "Extension must be at least 3 characters",
                  },
                  maxLength: {
                    value: 5,
                    message: "Extension must not exceed 5 characters",
                  },
                })}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onChange={(e) => {
                  if (e.target.value !== "") {
                    if (
                      e.target.value.length >= 3 &&
                      e.target.value.length <= 5
                    ) {
                      if (
                        parseInt(props.call_flow.extension) ===
                        parseInt(e.target.value)
                      ) {
                        clearErrors("extension");
                      } else {
                        checkAvailability(e);
                      }
                    } else {
                      setCheckAvailbility(false);
                      clearErrors("extension");
                    }
                    setValue("extension", parseInt(e.target.value), {
                      shouldDirty: true,
                    });
                  }
                }}
              />
              {errors.extension && (
                <>
                  {!checkAvailbility && (
                    <>
                      <p className="text-danger">{errors.extension.message}</p>
                    </>
                  )}

                  {checkAvailbility && (
                    <p style={{ color: "Green" }} className="clr-red">
                      {errors.extension.message}
                    </p>
                  )}
                </>
              )}
            </div>
          </div>

          <TelephoneNumbers
            savedPhoneNumbers={selectedPHnums}
            setSavedPhoneNumbers = {setSelectedPHnums}
            setSuccessMessage={setSuccessMessage}
            setUpdateNumbersExecuted={setUpdateNumbersExecuted}
            sourceNumber={sourceNumber}
            uniqueid={props.call_flow.call_flow_id}
            setDeleteNumberFlag={setDeleteNumberFlag}
            setUpdatePHNum={setUpdatePHNum}
            dbPhoneNumbers = {dbPhoneNumbers}
          />

          <div className="add-numbermain mb-5">
            <div className="tel-numbers">{t("location")}</div>
            <div className="phoneselect w-30">
              <select
                className="form-control form-select selectname w-100"
                name="San Jose"
                {...register("location", {
                  setValueAs: (value) => Number(value),
                })}
                onChange={(e) => {
                  setValue("location", parseInt(e.target.value), {
                    shouldDirty: true,
                  });
                }}
              >
                {locations &&
                  locations.map((item) => (
                    <>
                      <option
                        value={item.location_id}
                        selected={item.location_id == props.call_flow.loc_id}
                      >
                        {item.location_name}
                      </option>
                    </>
                  ))}
              </select>
            </div>
          </div>
          <br />
        </form>
      </div>
      {successMessage && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={10000}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{successMessage}</span>
        </MDBAlert>
      )}
      {isdirtyFields && (
        <SaveChanges
          onClose={closeSave}
          isdirtyFields={isdirtyFields}
          onSave={(e) => {
            e.preventDefault();
            handleSubmit(onsubmit)();
          }}
        />
      )}
    </>
  );
}
